import { Component } from '@angular/core';
import { LoaderComponent } from './shared/presentationals/loader/loader.component';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { DateAdapter } from '@angular/material/core';

// Use local script to avoid CSP violations
(window as any).pdfWorkerSrc = 'assets/scripts/pdf.worker.min.js';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [LoaderComponent, RouterOutlet]
})
export class AppComponent {
  constructor(readonly translateService: TranslateService, 
    readonly dateAdapter: DateAdapter<any>) {
    // Change language of date picker
    translateService.onLangChange.subscribe(() => { 
      dateAdapter.setLocale(translateService.currentLang);
    });
  }
}
